/**
 * Subtotal skeleton while a cart mutation is in flight.
 *
 * Every path that changes the cart (Dawn's quantity/remove, product-form
 * adds, the free-gift and Complete your ride adds, apps) goes through
 * fetch() against /cart/add|change|update|clear, so one wrapper covers them
 * all: while such a request is pending, every .totals block gets
 * `is-loading`. The response re-renders the totals (new element, no class);
 * a short fallback clears the class if nothing re-rendered, and errors clear
 * it immediately.
 */
(() => {
  if (window.__e13CartTotalsLoading) return;
  window.__e13CartTotalsLoading = true;

  const MUTATION = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  let pending = 0;

  const setLoading = (on) => {
    document.querySelectorAll('.totals').forEach((el) => el.classList.toggle('is-loading', on));
  };

  const originalFetch = window.fetch;
  window.fetch = function (input, init) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
    if (method === 'GET' || !MUTATION.test(url)) return originalFetch.apply(this, arguments);

    pending += 1;
    setLoading(true);
    return originalFetch.apply(this, arguments).then(
      (response) => {
        pending = Math.max(0, pending - 1);
        // Leave the skeleton up through the section re-render that follows;
        // the fresh totals element arrives without the class.
        if (!pending) setTimeout(() => { if (!pending) setLoading(false); }, 1200);
        return response;
      },
      (error) => {
        pending = Math.max(0, pending - 1);
        if (!pending) setLoading(false);
        throw error;
      }
    );
  };
})();
